<div class="product__box has-text-centered">
  <div class="product__box__head">
                <span class="product__box__title has-text-centered">
                    {{package.name}}
                </span>
    <hr>
    <div class="product__box__price has-text-centered">€ {{package.price}} / {{package.priceUnit}}</div>
  </div>
  <div class="triangle__wrapper">
    <div class="product__box__head__triangle">
    </div>
  </div>
  <div class="product__box__body">
    <div>
      <span><strong>{{package.text}}</strong></span>
    </div>
    <div *ngIf="package.additionalDocuments == false" class="product__box__description has-text-left">

      <ul>
        <li *ngFor="let document of package.documents" >
          <span>
            <a (click)="this.infoRequest.emit(document)" style="color: #363636 !important;">
              <strong>{{getLongName(document)}}</strong>
            </a>
          </span>
        </li>
        <app-modal [active]="displayInfo" (modalClosed)="displayInfo = false">
          <div style="text-align: justify"></div>
        </app-modal>
      </ul>
    </div>

  </div>


  <div class="product__box__footer">
    <div class="product__box__description">
      <span class="is-bold" style="color: #73b1d6">Grundbuchauszug</span> zur
      Eigentümerverifikation und Nachweis
      des berechtigten Interesses enthalten*
    </div>
    <div>
    <button id="package-2" class="product__box__button" (click)="selectEvent.emit(package.name)" [ngClass]="{'product__box__button_selected' : package.selected}">Auswählen</button>


    </div>
    <div style="margin-top: 5px;"> <span><a style="color: #73b1d6; font-size: 14px;" (click)="displayInfoMessage()" >MEHR INFOS</a></span> </div>

    <app-modal [active]="displayInfo" (modalClosed)="displayInfo = false">
      <div class="card__box" style="text-align: justify" [innerHTML]="package.moreInfos"></div>
    </app-modal>
  </div>


</div>

